/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: components.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/plugins/mock-content/core/components.js
 */

import MockContentLoading from '../components/MockContent.vue';

import MockCode from '../components/presets/Code.vue';
import MockList from '../components/presets/List.vue';
import MockTwitch from '../components/presets/Twitch.vue';
import MockFacebook from '../components/presets/Facebook.vue';
import MockInstagram from '../components/presets/Instagram.vue';
import MockBulletList from '../components/presets/BulletList.vue';
import MockTable from '../components/presets/Table.vue';

export default MockContentLoading;

export {
    MockCode,
    MockList,
    MockTwitch,
    MockFacebook,
    MockInstagram,
    MockBulletList,
    MockTable,
    MockContentLoading,
};
